<template>
  <button type="button" class="btn btn-sm btn-info center-block pull-left" @click.prevent="goBack()">
    <i class="fa fa-arrow-left"></i>&nbsp; Voltar
  </button>
</template>

<script>
export default {
  name: 'GoBackButton',
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// GoBackButton.vue?c8924b3c